module.exports = __webpack_public_path__ + "img/wm001.a7ce8b90.png";